const ExHub = () => {
    return (
        <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.6667 16L0 8L14.6667 0L29.3333 8L14.6667 16ZM14.6667 21.3333L0.766667 13.7667L3.56667 12.2333L14.6667 18.3L25.7667 12.2333L28.5667 13.7667L14.6667 21.3333ZM14.6667 26.6667L0.766667 19.1L3.56667 17.5667L14.6667 23.6333L25.7667 17.5667L28.5667 19.1L14.6667 26.6667ZM14.6667 12.9667L23.7667 8L14.6667 3.03333L5.56667 8L14.6667 12.9667Z" fill="#999B9F"/>
        </svg>

    )
}

export default ExHub